export default __webpack_public_path__ + "static/media/sit.8e81ec4a.png";